import { showCatalogItemDetails } from './action';
import {
    SET_ORDER,
    SET_MANAGED_EQUIPMENT_ITEM_DETAILS,
    SHOW_CATALOG_ITEM_DETAILS
} from './types';

const initialState = {
    orderDetails: {vehicleType: ''},
    catalogDetails:[],
    catalogDetailsFleetRequestDetailId: null,
    showCatalogItemDetails:false,
    noRecordsMessage: '',
}

const reducer = (state = initialState, action:any) => {
    switch (action.type) {
        case SET_ORDER:
            return {
              ...state,
              orderDetails: action.orderDetails
        }
        case SET_MANAGED_EQUIPMENT_ITEM_DETAILS:
            const catalogDetails = action.catalogDetails;
            const noRecordsMessage=action.noRecordsMessage
            const catalogDetailsFleetRequestDetailId = action.fleetRequestDetailId ?? null
            return {
              ...state, catalogDetails,noRecordsMessage, catalogDetailsFleetRequestDetailId
            };
            case SHOW_CATALOG_ITEM_DETAILS:
                return{
                    ...state,
                    payload: showCatalogItemDetails
                }
        default: return state
    }
}

export default reducer